<div class = "conversations">
    <h1>Conversations ({{dealerData.conversations == undefined ? 0 : dealerData.conversations?.length}})</h1>

    <div class = "conversation-list">
        <app-conversations
            [objectSource]="objectSource">
        </app-conversations>
    </div>

</div>
